import Enemy from './enemy';
import Player from './player';

export default class InfoBar {
    private _parent: Player | Enemy;
    private _rectangle: Phaser.GameObjects.Rectangle;
    private _rectangleFrame: string = null;
    public MAX_WIDTH: number;
    private _maxValue: number;
    private _offsetY: number = 0;
    public active: boolean = false;

    private _healthFill: Phaser.GameObjects.Image;
    private _bar: Phaser.GameObjects.Image;
    private _container: Phaser.GameObjects.Container;
    constructor(scene: Phaser.Scene, parent: Enemy, maxVal, width?:number, height?:number, key?:string, frame?:string, followParent?:boolean, x?:number, y?:number, container?:Phaser.GameObjects.Container) {
        let w = Math.round(window.constants.BASE_WIDTH * 0.125), h = Math.round(window.constants.BASE_HEIGHT * 0.02);
        this._maxValue = maxVal;
        this.MAX_WIDTH = width;
        // this._bar.setOrigin(0.5, 0.5);
        
        // this._container = scene.add.container(x, y);
        // this._container.add(this._rectangle);
        // this._container.add(this._bar);
        if(frame == "health_bar") {
            // console.log("hey")
            let health_fill = scene.textures.getFrame("assets", "health_fill");
            this._healthFill = scene.add.image(x - health_fill.width/2, y - health_fill.height/2, "assets", 'health_fill');
            this._healthFill.setOrigin(0, 0);
            this._healthFill.setTint(0x00ff00);
        } else {
            this._rectangle = scene.add.rectangle(x, y, width, height, 0x00ff00, 1.0);
            this._rectangleFrame = frame;
        }
        this._bar = scene.add.image(x, y, key, frame);
        
        if(followParent) {
            this._parent = parent;
            this._parent.parentContainer.add(this._rectangle);
            this._parent.parentContainer.add(this._bar);
            this._offsetY = Math.floor((parent.height * parent.scaleY)  * 0.6);
            this._setPosition(this._parent.x, this._parent.y);
            
        }
        // this._bar.setMask(this._rectangle.createBitmapMask());
        if(container!= undefined) {
            if(this._rectangle) {
                container.add(this._rectangle);
            }else {
                container.add(this._healthFill);
            }
            container.add(this._bar);
        }
        
        this.stop();

    }

    update(time, dt) {
        if(this._parent)
        {
            this._setPosition(this._parent.x, this._parent.y);
        }
    }

    public setValue(value) {
        if(this._rectangle) {
            this._rectangle.width = Math.max(Math.min(Math.round((value / this._maxValue) * this.MAX_WIDTH), this.MAX_WIDTH), 0);
            if(this._rectangleFrame == 'timer_bar_mini') {
                if(this._rectangle.width <= 50){
                    this._rectangle.fillColor = 0xff0000;
                } else if(this._rectangle.width > 50 && this._rectangle.width <= 100) {
                    this._rectangle.fillColor = 0xffff00;
                } else if(this._rectangle.width > 100) {
                    this._rectangle.fillColor = 0x00ff00;
                }
            }
            else if (this._rectangleFrame == 'timer_bar') {
                if(this._rectangle.width <= 87){
                    this._rectangle.fillColor = 0xff0000;
                } else if(this._rectangle.width > 87 && this._rectangle.width <= 175) {
                    this._rectangle.fillColor = 0xffff00;
                } else if(this._rectangle.width > 175) {
                    this._rectangle.fillColor = 0x00ff00;
                }
            }
        } else {
            this._healthFill.setDisplaySize(Math.max(Math.min(Math.round((value / this._maxValue) * this.MAX_WIDTH), this.MAX_WIDTH), 0), this._healthFill.height);
            if(value < 3){
                this._healthFill.setTint(0xff0000)
            } else if(value < 5) {
                this._healthFill.setTint(0xffa500);
            } else if(value <= 13) {
                this._healthFill.setTint(0x00ff00);
            }
        }
        // if(this._rectangle.width <= 0)
        // {
        //     // this.stop();
        // }
    }

    public stop()
    {
        this.active = false;
        if(this._rectangle) {
            this._rectangle.setVisible(false);
        }
        else {
            this._healthFill.setVisible(false);
        }
        this._bar.setVisible(false);
        // this._container.setActive(false);
        // this._container.setVisible(false);
        // this._setPosition(window.constants.DEAD_SPOT.x, window.constants.DEAD_SPOT.y);
    }

    public start()
    {
        this.active = true;
        // this._rectangle.setVisible(true);
        this._bar.setVisible(true);
        if(this._rectangle) {
            this._rectangle.setVisible(true);
            this._rectangle.width = this.MAX_WIDTH;
        }else {
            this._healthFill.setVisible(true);
            this._healthFill.width = this.MAX_WIDTH;
            this._healthFill.setTint(0x00ff00);
        }
        // this._container.setActive(true);
        // this._container.setVisible(true);
        if(this._parent) {
            this._setPosition(this._parent.x, this._parent.y);
        }       
    }

    private _setPosition(x, y)
    {
        // this._container.setPosition(x, y + this._offsetY);
        if(this._rectangle)
        {
            this._rectangle.x = x;
            this._rectangle.y = y + this._offsetY;
        }
        else {
            this._healthFill.x = x - (this._healthFill.width/2);
            this._healthFill.y = y - (this._healthFill.height/2);
        }
        this._bar.x = x;
        this._bar.y = y + this._offsetY;
    }

    public setDepth(z){
        this._bar.setDepth(z);
        if(this._rectangle) {
            this._rectangle.setDepth(z);
        }else {
            this._healthFill.setDepth(z);
        }
    }

}